<template>
 <div>
    <div>
    <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="390">
      <v-card>
        <v-card-title class="headline">Selecione o Trimestre</v-card-title>
         <v-col
            cols="12"
            md="12"
          >
            <v-select
            outlined
              v-model="trimestre"
              item-value="idTrimestre"
              item-text="descricao"
              :items="trimestres"
              :disabled="isUpdating"
               filled
              color="blue-grey lighten-2"
              label="Trimestre"
            ></v-select>
          </v-col>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog=false">Cancelar</v-btn>
           <v-btn color="green darken-1" text @click="comporBoletim()">Concordar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </div>
   <br>
   <v-card
    class="mx-auto"
  >

    <v-toolbar
      color="indigo"
      dark
    >
      <v-app-bar-nav-icon></v-app-bar-nav-icon>
         <v-btn
                  @click="backTodisciplinList"
                  class="mx-2"
                  fab
                  dark
                  color="primary"
                >
          <v-icon dark>arrow_back</v-icon>
        </v-btn>
      <v-toolbar-title>Aluno :  {{this.$store.state.objAluno.nome}} - {{this.$store.state.objAluno.idMAtricula}}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-toolbar>

    <v-container fluid>
      <v-row dense>
        <v-col xs="12" sm="12" md="12"

        >

          <strong>Geração de Boletim</strong>
           <v-icon @click="escolherOTrimestre()">print</v-icon>
           <v-progress-circular
                          v-if="progresso"
                          indeterminate
                          color="green"
                  ></v-progress-circular>
          <v-card>

               <template>
                   <v-simple-table class="tabela" fixed-header>
    <template v-slot:default>
      <thead>
        <tr>

        </tr>
      </thead>

      <tbody>
          <tr>
             <td rowspan="2" class="tabelath">Nº</td>
             <td rowspan="2" class="tabelath">Disciplina</td>
             <td colspan="4" class="tabelath">1º Trimestre</td>
            <td colspan="4" class="tabelath">2º Trimestre</td>
            <td colspan="3" class="tabelath">3º Trimestre</td>
            <td colspan="8" class="tabelath">Médias</td>
          </tr>
          <tr>
            <td  class="tabela">MAC</td>
            <td  class="tabela">P1</td>
            <td class="tabela">P2</td>
            <td class="tabela">MT</td>
            <td class="tabela">MAC</td>
            <td class="tabela">P1</td>
            <td class="tabela">P2</td>
            <td class="tabela">MT</td>
            <td class="tabela">MAC</td>
            <td class="tabela">P1</td>
            <td class="tabela">MT</td>
            <td class="tabela">MFD</td>
            <td class="tabela">EX</td>
            <td class="tabela">MF</td>
            <td class="tabela">REC</td>
        </tr>
        <tr v-for="(item,i) in listaAlunos" :key="i">
          <td  class="tabela">{{ i+1 }}</td>
          <td  class="tabela">{{ item.disciplina }}</td>
          <td  class="tabela">{{ item.t1_mac }}</td>
          <td  class="tabela">{{ item.t1_nota1 }}</td>
          <td  class="tabela">{{ item.t1_nota2 }}</td>
          <td v-if="(item.t1_md <10)" style="color:red" class="tabela">{{ item.t1_md }}</td>
          <td v-if="(item.t1_md >=10)" style="color:blue" class="tabela">{{ item.t1_md }}</td>
          <td  class="tabela">{{ item.t2_mac }}</td>
          <td  class="tabela">{{ item.t2_nota1 }}</td>
          <td  class="tabela">{{ item.t2_nota2 }}</td>
          <td v-if="(item.t2_md <10)" style="color:red" class="tabela">{{ item.t2_md }}</td>
          <td v-if="(item.t2_md>=10)" style="color:blue" class="tabela">{{ item.t2_md }}</td>
          <td  class="tabela">{{ item.t3_mac }}</td>
          <td  class="tabela">{{ item.t3_nota1 }}</td>
          <td v-if="(item.t3_md <10)" style="color:red" class="tabela">{{ item.t3_md }}</td>
          <td v-if="(item.t3_md>=10)" style="color:blue" class="tabela">{{ item.t3_md }}</td>
           <td v-if="(item.t3_md <10)" class="tabela">{{ item.MF }}</td>
          <td  class="tabela">{{ item.MF }}</td>
          <td v-if="(item.pg  <10)" style="color:red" class="tabela">{{ item.pg }}</td>
          <td v-if="(item.pg >=10)" style="color:blue" class="tabela">{{ item.pg }}</td>
          <td v-if="(item.mfd  <10)" style="color:red" class="tabela">{{ item.mfd }}</td>
          <td v-if="(item.mfd >=10)" style="color:blue" class="tabela">{{ item.mfd }}</td>
          <td v-if="(item.recurso  < 10)" style="color:red" class="tabela">{{ item.recurso }}</td>
          <td v-if="(item.recurso >=10)" style="color:blue" class="tabela">{{ item.recurso }}</td>

        </tr>
      </tbody>
    </template>
  </v-simple-table>
                </template>

          </v-card>
        </v-col>
         <!--   -->

         <v-col md="0"

        >

             <!--   <v-list-item-avatar
                style="width:250px;height:200px;margin-top:80px;margin-left:20px"
                  tile
                  size="80"
                  color="grey"
                ></v-list-item-avatar>-->
        </v-col>
      </v-row>
  <!-- =============================================================================== -->
    </v-container>
  </v-card>
 </div>
</template>
<script>
import axios from '../../../../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    configuracoesReport: [],
    insignia: ls.get('insignia'),
    logotipo: (ls.get('i_id') === 24 ? ls.get('logotipo') : ls.get('insignia')),
    progresso: false,
    cards: [
      { title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 12 },
      { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 },
      { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }
    ],
    listaAlunos: [],
    html: ``,
    url: '',
    pdf: [],
    arrayTrimestreFirst: [],
    arrayTrimestreSecond: [],
    arrayTrimestreThird: [],
    dialog: false,
    isUpdating: false,
    trimestre: 0,
    dialogCert: false,
    canPrint: [],
    anoAcademicos: [
      {
        idAno_academico: 1,
        descricao: '10ª'
      },
      {
        idAno_academico: 2,
        descricao: '11ª'
      },
      {
        idAno_academico: 3,
        descricao: '12ª'
      },
      {
        idAno_academico: 4,
        descricao: '13ª'
      }
    ],
    trimestres: [{
      idTrimestre: 1,
      descricao: '1º Trimestre'
    },
    {
      idTrimestre: 2,
      descricao: '2º Trimestre'
    },
    {
      idTrimestre: 3,
      descricao: '3º Trimestre'
    },
    {
      idTrimestre: 4,
      descricao: 'Todos'
    }
    ],
    headers: [
      {
        text: 'Disciplina',
        align: 'start',
        sortable: false,
        value: 'disciplina'
      },
      { text: 'Nota', value: 'fat' },
      { text: 'Cadeirante', value: 'carbs' },
      { text: 'Resultante', value: 'protein' }
    ]
  }),

  created () {
    this.CarregaBoletim()
    this.carregarConfiguracoesReports()
  },

  methods: {
    async CarregaBoletim () {
      this.progresso = true

      const valor =
          {
            pkInscricao_na_turma: this.$store.state.objAluno.pkInscricao_na_turma
          }

      try {
        this.listaAlunos = await axios
          .post('/gerarBoletim', valor)
          .then(res => res.data)
        this.progresso = false
        if (this.listaAlunos.length > 0) { this.listaAlunos = this.listaAlunos[0] }
        this.filterBoletimAlunos(this.listaAlunos)
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async filterBoletimAlunos (arrayAllPauta) {
      for (let i = 0; i < arrayAllPauta.length; i++) {
        this.arrayTrimestreFirst.push({ disciplina: arrayAllPauta[i].disciplina, mac: arrayAllPauta[i].t1_mac, p1: arrayAllPauta[i].t1_nota1, p2: arrayAllPauta[i].t1_nota2, md: arrayAllPauta[i].t1_md })
        this.arrayTrimestreSecond.push({ disciplina: arrayAllPauta[i].disciplina, mac: arrayAllPauta[i].t2_mac, p1: arrayAllPauta[i].t2_nota1, p2: arrayAllPauta[i].t2_nota2, md: arrayAllPauta[i].t2_md })
        this.arrayTrimestreThird.push({ disciplina: arrayAllPauta[i].disciplina, mac: arrayAllPauta[i].t3_mac, p1: arrayAllPauta[i].t3_nota1, md: arrayAllPauta[i].t3_md })
      }
    },
    escolherOTrimestre () {
      this.disabled = false
      this.dialog = true
    },
    // this.$store.state.objAluno
    
    async comporBoletim () {
      try {
        let boletimConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'nome_escola')
        let assinatura = (ls.get('i_id') === 24 ? 'O(A) Director(a) de Turma' : 'O Coordenador do Curso')
        this.dialogCert = false
        let boletimAluno = []
        let dadosBoletim = ``

        if (this.trimestre > 0 && this.trimestre < 5) {
          this.progresso = true
          // eslint-disable-next-line no-unused-vars
          let classe = this.anoAcademicos.filter(t => t.idAno_academico === this.$store.state.objAluno.idAno_Academico)
          // Boletim do Aluno em função do Trimestre
          if (this.trimestre === 1)boletimAluno = this.arrayTrimestreFirst
          else
          if (this.trimestre === 2)boletimAluno = this.arrayTrimestreSecond
          else
          if (this.trimestre === 3) boletimAluno = this.arrayTrimestreThird
          else
          if (this.trimestre === 4) {
            boletimAluno = this.listaAlunos
          }
          if (this.trimestre >= 1 && this.trimestre < 3) {
            boletimAluno.forEach(element => {
              dadosBoletim += `<tr class="item">
                    <td style="text-align:justify;"> ` + element.disciplina + `</td>
                    <td>` + this.isNull(element.mac) + ` </td>
                    <td> ` + this.isNull(element.p1) + `</td>
                    <td>  ` + this.isNull(element.p2) + ` </td>
                    <td>` + this.isNull(element.md) + ` </td>
                </tr>`
            })

            this.html = `<html>
<head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
    <style>
    .invoice-box table tr.cabecalho td {
  text-align:justify;
  font-size: 10px;
}
.invoice-box table tr.footer td {
  text-align:center;
  font-size: 10px;
}

p{
  text-align:center;
  font-size: 11px;
}
.invoice-box {
max-width: 800px;
margin: auto;
padding: 10px;
border: 1px solid #eee;

line-height: 14px;
font-family: Arial, sans-serif;
color: #555;
}
.invoice-box table {
width: 100%;
line-height: inherit;
text-align: left;
}
.invoice-box table td {
padding: 2px;
vertical-align: top;
}
.invoice-box table tr td:nth-child(2) {
text-align: right;
}
.invoice-box table tr.top table td {
padding-bottom: 5px;
}
.invoice-box table tr.top table td.title {
line-height: 45px;
color: #333;
}
.invoice-box table tr.information table td {
padding-bottom: 5px;
}
.invoice-box table tr.heading td {
background: #eee;
border-bottom: 1px solid #ddd;
font-weight: bold;
font-size: 11px;
text-align:center;
}
.invoice-box table tr.details td {
padding-bottom: 5px;
}
.invoice-box table tr.item td {
  border-bottom: 1px solid #eee;
  text-align:center;
  font-size: 10px;
  padding-top:5px;
  border: 1px solid #eee;
}
.invoice-box table tr.item.last td {
border-bottom: none;
}
.invoice-box table tr.total td:nth-child(2) {
border-top: 2px solid #eee;
font-weight: bold;
}
@media only screen and (max-width: 600px) {
.invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
}
.invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
}
}
    </style>
</head>
<body>
    <div class="invoice-box">
                        
<center> <img src="` + this.logotipo + `" alt="Snow" style="width:50%; max-width:50px;height:50px;" /> </center><br>
                             <center style="font-size: 10px;font-weight:bold;">  REPÚBLICA DE ANGOLA <br>
                           MINISTÉRIO DA EDUCAÇÃO <br>
                           INSTITUTO TÉCNICO PRIVADO DE SAÚDE  <br>
                           ` + ls.get('instituicaodescricao').toUpperCase() + `
                        </center> 
               <div style="text-align:center;font-size: 9px ;padding:10px;font-weight:bold;">BOLETIM DE NOTAS<div/>
            <table  border="0" cellpadding="0" cellspacing="0">
                 
                <tr >
                    <td colspan="5">
                        <table border="0">
                            <tr class="cabecalho">
                                <td>
                                    <strong> Nome: ` + this.$store.state.objAluno.nome.toUpperCase() + `</strong> <br>
                                     Nº de Processo: ` + this.$store.state.objAluno.idMAtricula + `<br>
                                     Ano lectivo: ` + this.$store.state.objAluno.anoLectivo + `<br>
                                Curso: ` + this.$store.state.objAluno.curso + `                                 
                                </td>
                                <td>
                              Turma: ` + this.$store.state.objAluno.turma + `  <br>
                                Periodo: ` + this.$store.state.objAluno.periodo + `<br>
                                Classe: ` + this.$store.state.objAluno.classe.substring(0, 3) + `
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr class="heading">
                    <td rowspan="2">
                   Disciplinas
                    </td>
                    <td colspan="4">
                      ` + this.trimestre + `º Trimestre 
                    </td>
                </tr>
                  <tr class="heading">
                    <td>Mac </td>
                    <td> P1</td>
                     <td> P2</td>
                     <td>MT</td>
                </tr>
        ` + dadosBoletim + `
            </table>
            <div >
  <p>Para os devidos efeitos, passou-se o presente Boletim de Notas que vai por mim assinado.</p>
    <p>Luanda, ` + this.dia() + ` de ` + this.monthName() + `</p> 
    <table>
          <tr class="footer">
            
          <td width="45%">` + assinatura + `</td>
          <td width="10%"></td>
          <td width="45%">O SubDirector(a) Pedagógico(a)</td>
          </tr>
    <tr class="footer">
        <td width="45%">_____________________________</td>
        <td width="10%"></td>
        <td width="45%">_____________________________</td>
    </tr>
</table>
      <p>Saúde e sabedoria!</p>
</div>
        </div>
    </body>
</html>
`
            let option = { 'format': 'A5' }
            this.boletimgerarPdf(option)
          } else
          if (this.trimestre === 3) {
            boletimAluno.forEach(element => {
              dadosBoletim += `<tr class="item">
                    <td style="text-align:justify;">
                        ` + element.disciplina + `
                    </td>
                    <td>
                        ` + this.isNull(element.mac) + ` 
                    </td>
                    <td>
                        ` + this.isNull(element.p1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.md) + `
                    </td>
                </tr>`
            })

            this.html = `<html>
<head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
    <style>
    .invoice-box table tr.cabecalho td {
  text-align:justify;
  font-size: 10px;
}
.invoice-box table tr.footer td {
  text-align:center;
  font-size: 10px;
}

p{
  text-align:center;
  font-size: 11px;
}
.invoice-box {
max-width: 800px;
margin: auto;
padding: 10px;
border: 1px solid #eee;
line-height: 14px;
font-family: Arial, sans-serif;
color: #555;
}
.invoice-box table {
width: 100%;
line-height: inherit;
text-align: left;
}
.invoice-box table td {
padding: 5px;
vertical-align: top;
}
.invoice-box table tr td:nth-child(2) {
text-align: right;
}
.invoice-box table tr.top table td {
padding-bottom: 20px;
}
.invoice-box table tr.top table td.title {
font-size: 45px;
line-height: 45px;
color: #333;
}
.invoice-box table tr.information table td {
padding-bottom: 40px;
}
.invoice-box table tr.heading td {
  background: #eee;
border-bottom: 1px solid #ddd;
font-weight: bold;
font-size: 11px;
text-align:center;
}
.invoice-box table tr.details td {
padding-bottom: 20px;
}
.invoice-box table tr.item td {
  border-bottom: 1px solid #eee;
  text-align:center;
  font-size: 10px;
  padding-top:5px;
  border: 1px solid #eee;
}
.invoice-box table tr.item.last td {
border-bottom: none;
}
.invoice-box table tr.total td:nth-child(2) {
border-top: 2px solid #eee;
font-weight: bold;
}
@media only screen and (max-width: 600px) {
.invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
}
.invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
}
}
    </style>
</head>
<body>
    <div class="invoice-box">
                        
<center> <img src="` + this.logotipo + `" alt="Snow" style="width:50%; max-width:50px;" /> </center><br>
                             <center style="font-size: 10px;">  REPÚBLICA DE ANGOLA <br>
                           MINISTÉRIO DA EDUCAÇÃO <br>
                        ` + (boletimConfiguracoes[0].valor).toUpperCase() + `</center> 
               <div style="text-align:center;font-size: 10px ;padding:10px;">BOLETIM DE NOTAS<div/>
            <table  border="0" cellpadding="0" cellspacing="0">
                 
                <tr>
                    <td colspan="5">
                        <table border="0">
                            <tr class="cabecalho">
                                <td>
                                    <strong> Nome: ` + this.$store.state.objAluno.nome.toUpperCase() + `</strong> <br>
                                     Nº de Processo: ` + this.$store.state.objAluno.idMAtricula + `<br>
                                     Ano lectivo: ` + this.$store.state.novadescricaoSelecionado + `<br>
                                Curso: ` + this.$store.state.objAluno.curso + `                                 
                                </td>
                                <td style="text-align: justify; padding-left:0px">
                              Turma: ` + this.$store.state.objAluno.turma + `  <br>
                                Periodo: ` + this.$store.state.objAluno.periodo + `<br>
                                Classe: ` + this.$store.state.objAluno.classe.substring(0, 3) + `
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr class="heading">
                    <td rowspan="2"> Disciplinas</td>
                    <td colspan="4">` + this.trimestre + `º Trimestre </td>
                </tr>
                  <tr class="heading">
                    <td>Mac</td>
                    <td> P1 </td>
                     <td colspan="2"> MT</td>
                </tr>
        ` + dadosBoletim + `
            </table>
            <div >
  <p>Para os devidos efeitos, passou-se o presente Boletim de Notas que vai por mim assinado.</p>
    <p>Luanda, ` + this.dia() + ` de ` + this.monthName() + `</p> 
    <table>
          <tr class="footer">
            
          <td width="45%">` + assinatura + `</td>
          <td width="10%"></td>
          <td width="45%">O SubDirector(a) Pedagógico(a)</td>
          </tr>
    <tr class="footer">
        <td width="45%">_____________________________</td>
        <td width="10%"></td>
        <td width="45%">_____________________________</td>
    </tr>
</table>
      <p>Saúde e sabedoria!</p>
</div>
        </div>
    </body>
</html>
`
            let option = { 'format': 'A5' }
            this.boletimgerarPdf(option)
          } else
          if (this.trimestre === 4) {
            boletimAluno.forEach(element => {
              dadosBoletim += `  <tr class="item">
                    <td style="text-align:justify;">
                        ` + element.disciplina + `
                    </td>
                    <td>
                        ` + this.isNull(element.t1_mac) + ` 
                    </td>
                    <td>
                       ` + this.isNull(element.t1_nota1) + ` 
                    </td>
                    <td>
                          ` + this.isNull(element.t1_nota2) + `
                    </td>
                    <td>
                        ` + this.isNull(element.t1_md) + `
                    </td>
                  <td>
                        ` + this.isNull(element.t2_mac) + `
                    </td>
                    <td>
                           ` + this.isNull(element.t2_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_md) + `
                    </td>
                <td>
                         ` + this.isNull(element.t3_mac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_md) + `
                    </td>
               
                    <td>
                         ` + this.isNull(element.mfd) + `
                    </td>
                    <td>
                         ` + this.isNull(element.exame) + `
                    </td>
                  <td>
                         ` + this.isNull(element.recurso) + `
                    </td>
                    <td>
                        <span class=` + (element.mf_cor) + `>  ` + this.isNull(element.mf) + `</span>
                    </td>
                </tr>
                `
            })

            this.html = `<html>
<head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
    <style>
    body { font-family: Arial, Helvetica, sans-serif;}
.invoice-box {
max-width: 800px;
margin: auto;
padding: 10px;
border: 1px solid #eee;
line-height: 14px;
font-family: Arial, sans-serif;
color: #555;
}
.invoice-box table {
width: 100%;
line-height: inherit;
text-align: left;
}
.NaoTransita{
        color: red
}

.invoice-box table tr.heading td {
background: #eee;
border-bottom: 1px solid #ddd;
border-right: 1px solid #ddd;
font-weight: bold;
padding-top:10px;
font-size: 11px;
text-align:center;
}
.invoice-box table tr.cabecalho td {
  text-align:justify;
  font-size: 10px;
}
.invoice-box table tr.footer td {
  text-align:center;
  font-size: 10px;
}
.invoice-box table tr.item td {
  text-align:center;
  font-size: 10px;
  padding-top:5px;
  border: 1px solid #eee;
}
p{
  text-align:center;
  font-size: 11px;
}
    </style>
</head>
<body>
    <div class="invoice-box" >
                        
<center> <img src="` + this.logotipo + `" alt="Snow" style="width:20%; max-width:40px;" /> </center><br>
                     <center style="font-size: 12px ">  REPÚBLICA DE ANGOLA <br>
                           MINISTÉRIO DA EDUCAÇÃO <br>
                        ` + (boletimConfiguracoes[0].valor).toUpperCase() + `</center>         
               <div style="text-align:center;font-size: 12px ;padding-top:10px;">BOLETIM DE NOTAS<div/><br>
       
                 
                         <table>
                            <tr class="cabecalho">
                                <td>
                                    <strong> Nome:  ` + this.$store.state.objAluno.nome.toUpperCase() + `</strong> <br>
                                     Nº de Processo: ` + this.$store.state.objAluno.idMAtricula + `<br>
                                     Ano lectivo: ` + this.$store.state.novadescricaoSelecionado + `<br>
                                Curso: ` + this.$store.state.objAluno.curso + `                             
                                </td>
                                <td>
                              Turma: ` + this.$store.state.objAluno.turma + ` <br>
                                Periodo: ` + this.$store.state.objAluno.periodo + `<br>
                                Classe: ` + this.$store.state.objAluno.classe.substring(0, 3) + `
                                </td>
                            </tr>
                        </table>

                        <table cellpadding="0" cellspacing="0">
                  
                <tr class="heading">
                    <td rowspan="2">
                   Disciplinas
                    </td>
                    <td colspan="4"> 1º Trimestre  </td>
                    <td colspan="4"> 2º Trimestre  </td>
                    <td colspan="3">3º Trimestre </td>
                    <td colspan="5">Médias </td>
                </tr>
                  <tr class="heading">
                    <td>Mac</td>
                    <td>P1</td>
                     <td> P2</td>
                     <td> MT</td>

                     <td>Mac</td>
                    <td>P1</td>
                     <td> P2</td>
                     <td> MT</td>

                     <td>Mac</td>
                    <td>P1</td>
                     <td>MT</td>

                      
                    <td>MFD</td>
                     <td>EX</td>
                     <td>RC </td>
                     <td> MF</td>
                    
                </tr>
        ` + dadosBoletim + `
        </table>
            <div>
              <p>Para os devidos efeitos, passou-se o presente Boletim de Notas que vai por mim assinado.</p>
              <p>Luanda, ` + this.dia() + ` de ` + this.monthName() + `</p> 

      <table>
          <tr class="footer">
            <td width="10%"></td>
          <td width="40%">` + assinatura + `</td>
          <td width="40%">O SubDirector(a) Pedagógico(a)</td>
          <td  width="10%"></td>
          </tr>
    <tr class="footer">
      <td  width="10%"></td>
        <td width="40%">_____________________________</td>
        <td width="40%">_____________________________</td>
        <td width="10%"></td>
    </tr>
</table>
      <p>Saúde e sabedoria!</p>
</div>
        </div>
    </body>
</html>
`
            let option = { 'format': 'A4' }
            this.boletimgerarPdf(option)
          }

          this.dialog = false
        }
      } catch (error) {
        this.progresso = false
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    isNull (nota) {
      if (nota) { return nota } else return ''
    },
    rascunho (putRascunho) {
      return putRascunho === true ? this.rascunhoimge : ''
      // return ''
    },
    async boletimgerarPdf (option) {
      try {
        await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile', //  http://localhost:8082
          data: {
            html: this.html,
            file_name: ls.get('idPessoa'),
            option: option
          }
        }).then(function (response) {
        })
        // Imprimir PDF

        this.progresso = false
        this.frameBoletim()
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
        this.progresso = false
      }
    },
    frameBoletim () {
      this.url = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" type="application/pdf" src="` + this.url + `"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
      this.progresso = false
    },

    monthName () {
      let d = new Date()
      let month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return month[d.getMonth()] + ' ' + 'de' + ' ' + (d.getFullYear()).toString()
    },
    dia () {
      var day = new Date()
      day = day.getDate()
      day = day.toString()
      return day
    },
    async carregarConfiguracoesReports () {
      try {
        let msg = await axios
          .post('/configuracoes', { empresa: 'report' })
          .then(res => res.data)
        if (msg.length > 0) {
          this.configuracoesReport = msg
        }
      } catch (error) {

      }
    },
    backTodisciplinList () {
      this.$router.push(this.$store.state.backTo)
    }
  }
}
</script>
<style>
 .tabela {
    border: 1px solid rgba(0,0,0,.12);
    font-size: 12px!important;

}
 .tabelath {
    border: 1px solid rgba(0,0,0,.12);
    font-size: 12px !important;
}
.tdsize {
    width: 3px!important;
}

</style>
